import React from "react";

const ReadyToTakeOffSection = () => {
  return (
    <div className="px-10">
        <section
      className="relative w-full bg-cover bg-center bg-no-repeat h-[600px] flex items-center justify-center rounded-3xl"
      style={{
        backgroundImage:
          "url('https://mhcockpit.com/Media/4%20Aviators/Home/register.jpg')", // ✈️ Replace with your preferred aviation background
      }}
    >
      {/* Overlay for better text visibility */}
      {/* <div className="absolute inset-0 bg-black bg-opacity-60 rounded-3xl"></div> */}

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-3xl">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          Ready to Take Off With Us?
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6">
          Have a question, dream? Let’s connect and make your aviation journey a reality.
        </p>
        <a href="/contact-us" className="bg-[#012D6F] hover:bg-[#023a8a] text-white px-6 py-3 rounded-full font-semibold transition-all duration-300">
          Contact Us
        </a>
      </div>
    </section>
        </div>
  );
};

export default ReadyToTakeOffSection;
